(function () {
  'use strict';

  const POPUP_SEL = '.avis-popup-atc-content';
  const FOOTER_SEL = '.avis-popup-atc-footer';
  const TOTAL_WRAPPER_SEL = '.avis-popup-total-wrapper';
  const ATC_BTN_SEL = '.avis-popup-btn-atc';
  const QTY_PER_ORDER = 10;

  function readCurrencyPrefix() {
    const el = document.querySelector(TOTAL_WRAPPER_SEL);
    if (!el) return '';
    const m = (el.textContent || '').match(/([A-Za-z₹$€£.\s]*?)\s*[\d.,]+/);
    if (!m) return '';
    return m[1].replace(/Total\s*:?/i, '').trim();
  }

  function formatMoney(cents) {
    const value = Number(cents) / 100;
    const prefix = readCurrencyPrefix();
    const digits = value % 1 === 0 ? 0 : 2;
    const formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: digits,
      maximumFractionDigits: 2
    });
    return prefix ? prefix + ' ' + formatted : formatted;
  }

  function getSelectedPaidOptions() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return [];
    const inputs = popup.querySelectorAll('input[data-variant-price]:checked');
    const out = [];
    for (const input of inputs) {
      const price = Number(input.getAttribute('data-variant-price') || 0);
      if (!price) continue;
      const rawName = (input.value || '').trim();
      const name = rawName.replace(/\s*\[\s*[^\]]+\s*\]\s*$/, '').trim();
      out.push({ name: name || rawName, pricePerUnit: price });
    }
    return out;
  }

  function ensureBreakdownEl() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return null;
    const footer = popup.querySelector(FOOTER_SEL);
    if (!footer) return null;
    let el = footer.querySelector('.personalised-breakdown');
    if (!el) {
      el = document.createElement('div');
      el.className = 'personalised-breakdown';
      const totalWrapper = footer.querySelector(TOTAL_WRAPPER_SEL);
      if (totalWrapper) footer.insertBefore(el, totalWrapper);
      else footer.prepend(el);
    }
    return el;
  }

  function buildLineItem(item) {
    const li = document.createElement('li');
    li.className = 'personalised-breakdown__item';
    const name = document.createElement('span');
    name.className = 'personalised-breakdown__name';
    name.textContent = item.name;
    const price = document.createElement('span');
    price.className = 'personalised-breakdown__price';
    price.textContent = '+' + formatMoney(item.pricePerUnit);
    li.appendChild(name);
    li.appendChild(price);
    return li;
  }

  // === Chooser-change reset ===========================================
  // Avis tracks initial-step selection via qty inputs, not checkbox state.
  // When the qty>0 option changes (user picks Birthday Star then switches to
  // Party Squad), clear all downstream selections so the cart never receives
  // a mismatched mix of values from a previously-chosen path.
  let lastInitialChoice = null;
  let popupWasOpen = false;

  function getInitialChoice() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return null;
    const initial = popup.querySelector('.avp-option.initial-step');
    if (!initial) return null;
    const qtyInputs = initial.querySelectorAll('input.avp-qty-input');
    for (const q of qtyInputs) {
      if (Number(q.value || 0) > 0) {
        const item = q.closest('.avp-value-grid-item');
        const prev = item ? item.previousElementSibling : null;
        const cb = prev ? prev.querySelector('input[type="checkbox"], input[type="radio"]') : null;
        return cb ? cb.value : null;
      }
    }
    return null;
  }

  function resetSubsequentSteps() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;
    const opts = popup.querySelectorAll('.avp-option');
    for (const o of opts) {
      if (o.classList.contains('initial-step')) continue;
      o.classList.remove('completed-step');
      const checks = o.querySelectorAll(
        'input[type="checkbox"]:checked, input[type="radio"]:checked'
      );
      for (const c of checks) {
        c.checked = false;
        c.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const qtys = o.querySelectorAll('input.avp-qty-input');
      for (const q of qtys) {
        if (q.value !== '0' && q.value !== '') {
          q.value = '0';
          q.dispatchEvent(new Event('input', { bubbles: true }));
          q.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const texts = o.querySelectorAll('input[type="text"], textarea');
      for (const t of texts) {
        if (t.value) {
          t.value = '';
          t.dispatchEvent(new Event('input', { bubbles: true }));
          t.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  function trackPopupTransition() {
    const isOpen = !!document.querySelector(POPUP_SEL);
    if (isOpen && !popupWasOpen) {
      popupWasOpen = true;
      lastInitialChoice = getInitialChoice();
    } else if (!isOpen && popupWasOpen) {
      popupWasOpen = false;
    }
  }

  function checkChooserChange() {
    if (!popupWasOpen) return;
    const current = getInitialChoice();
    if (current === lastInitialChoice) return;
    const prev = lastInitialChoice;
    lastInitialChoice = current;
    if (prev !== null) {
      resetSubsequentSteps();
    }
  }

  function getActiveStepEl() {
    const popup = document.querySelector(POPUP_SEL);
    return popup ? popup.querySelector('.avp-option.active-tab') : null;
  }

  function isStepRequired(stepEl) {
    const fs = stepEl ? stepEl.querySelector('fieldset') : null;
    return fs ? fs.getAttribute('apo-required') === 'true' : false;
  }

  function isNameStep(stepEl) {
    return !!(stepEl && stepEl.querySelector('textarea, input[type="text"]'));
  }

  function isStepComplete(stepEl) {
    if (!stepEl) return false;
    const texts = stepEl.querySelectorAll('textarea, input[type="text"]');
    if (texts.length) {
      for (const t of texts) {
        if ((t.value || '').trim().length > 0) return true;
      }
      return false;
    }
    const fs = stepEl.querySelector('fieldset');
    if (!fs) return false;
    const max = Number(fs.getAttribute('max_total_qty') || 0);
    const qtys = fs.querySelectorAll('input.avp-qty-input');
    let total = 0;
    for (const q of qtys) total += Number(q.value || 0);
    if (max && total >= max) return true;
    if (!max && total > 0) return true;
    return false;
  }

  function getButtonState() {
    const active = getActiveStepEl();
    if (!active) return { label: 'Next', disabled: true, action: 'none' };
    const complete = isStepComplete(active);
    const required = isStepRequired(active);
    if (isNameStep(active)) {
      return {
        label: 'Add to cart',
        disabled: !complete,
        action: complete ? 'submit' : 'none'
      };
    }
    if (required) {
      return {
        label: 'Next',
        disabled: !complete,
        action: complete ? 'next' : 'none'
      };
    }
    return {
      label: complete ? 'Next' : 'Skip',
      disabled: false,
      action: 'next'
    };
  }

  function moveStep(delta) {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;
    const opts = [...popup.querySelectorAll('.avp-option')];
    const enabled = opts.filter(o => !o.hasAttribute('disabled'));
    const idx = enabled.findIndex(o => o.classList.contains('active-tab'));
    if (idx < 0) return;
    const target = idx + delta;
    if (target < 0 || target >= enabled.length) return;
    if (typeof window.setActiveStep === 'function') {
      window.setActiveStep(target);
    } else {
      enabled.forEach(o => o.classList.remove('active-tab'));
      enabled[target].classList.add('active-tab');
    }
  }

  function advanceStep() { moveStep(1); }
  function goBackStep() { moveStep(-1); }

  function getActiveEnabledIndex() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return -1;
    const enabled = [...popup.querySelectorAll('.avp-option:not([disabled])')];
    return enabled.findIndex(o => o.classList.contains('active-tab'));
  }

  function ensureBackButton() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return null;
    const atc = popup.querySelector(ATC_BTN_SEL);
    if (!atc) return null;
    let back = popup.querySelector('.personalised-back-btn');
    if (!back) {
      back = document.createElement('button');
      back.type = 'button';
      back.className = 'personalised-back-btn';
      back.textContent = 'Back';
      back.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        goBackStep();
      });
      atc.parentElement.insertBefore(back, atc);
    }
    return back;
  }

  function attachButtonHandler() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;
    const btn = popup.querySelector(ATC_BTN_SEL);
    if (!btn || btn.dataset.gateBound) return;
    btn.dataset.gateBound = '1';
    btn.addEventListener('click', function (e) {
      const action = btn.dataset.gateAction;
      if (action === 'next') {
        e.preventDefault();
        e.stopImmediatePropagation();
        advanceStep();
      } else if (action === 'none') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  function applyGate() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;
    const btn = popup.querySelector(ATC_BTN_SEL);
    if (!btn) return;
    attachButtonHandler();
    const state = getButtonState();
    btn.textContent = state.label;
    btn.disabled = state.disabled;
    btn.classList.toggle('is-locked', state.disabled);
    btn.dataset.gateAction = state.action;

    const back = ensureBackButton();
    if (back) {
      const idx = getActiveEnabledIndex();
      back.disabled = idx <= 0;
      back.classList.toggle('is-locked', back.disabled);
    }
  }

  function render() {
    trackPopupTransition();
    checkChooserChange();
    applyGate();
    const el = ensureBreakdownEl();
    if (!el) return;
    el.replaceChildren();

    const items = getSelectedPaidOptions();
    if (!items.length) {
      el.hidden = true;
      return;
    }

    const title = document.createElement('div');
    title.className = 'personalised-breakdown__title';
    title.textContent = 'Add-ons selected';

    const list = document.createElement('ul');
    list.className = 'personalised-breakdown__list';
    for (const item of items) list.appendChild(buildLineItem(item));

    el.append(title, list);
    el.hidden = false;
  }

  let scheduled;
  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(render, 80);
  }

  document.addEventListener('change', function (e) {
    const t = e.target;
    if (t && t.closest && t.closest(POPUP_SEL)) schedule();
  });

  document.addEventListener('input', function (e) {
    const t = e.target;
    if (t && t.closest && t.closest(POPUP_SEL)) schedule();
  });

  document.addEventListener('click', function (e) {
    const t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.avis-btn-open-popup') || t.closest(POPUP_SEL)) schedule();
  });

  // Avis can update qty inputs without firing events — poll while popup is open.
  setInterval(function () {
    if (document.querySelector(POPUP_SEL)) schedule();
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
